module.exports = __webpack_public_path__ + "img/Skirt-Front-B3-Da-Fb-Ga-Hc-Ia.30a953b0.png";